import { ProductCategory } from "gen/company/models_pb"
import { useMemo } from "react"
import { useIdFilter } from "shared-ts/hooks/useFilter"

import { useListProductCategoriesForCompanyV2Query } from "features/api/company"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export function useProductCategoryFilter({
  persistInUrl = true,
  key = "productCategory",
  initialSelectedOptions = [],
  allowExternalValues = false,
}: Partial<
  Pick<
    UseWebFilterProps<unknown>,
    "persistInUrl" | "key" | "initialSelectedOptions" | "allowExternalValues"
  >
> = {}) {
  const { data } = useListProductCategoriesForCompanyV2Query({})

  const allCategories = useMemo(() => {
    const categories: ProductCategory[] = []
    if (data?.departments) categories.push(...data.departments)
    if (data?.classes) categories.push(...data.classes)
    if (data?.finelines) categories.push(...data.finelines)
    return categories
  }, [data])

  const { filter, selected: selectedCategoryIds } = useIdFilter({
    key,
    label: "Product category",
    values: allCategories,
    labelExtractor: (category) => category.name,
    allowExternalValues,
    useFilter: (props) => {
      return useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      })
    },
  })

  return { filter, selectedCategoryIds }
}
